export default __webpack_public_path__ + "images/6a46093873851ba1005b4ff10fe4f6c1-dallas_desktop.webp";